@let $inputId = inputId();

<div class="mbs-form-group">
  @if (showLabel()) {
    <label
      class="mbs-form_label -accented -sm"
      [for]="$inputId">
      {{ label() }}
    </label>
  }

  <div class="row g-0">
    <div class="col-9">
      <mbs-input
        [clearButton]="true"
        [formControl]="formControl()"
        [id]="$inputId"
        [placeholder]="placeholder()"
        [type]="inputType()"
        (clear)="handleReset()"
        (keyup.enter)="handleAddValue()" />
    </div>
    <div class="col-3 pl-2">
      <mbs-button
        [block]="true"
        [disabled]="isFormCtrlValid"
        (click)="handleAddValue()">
        {{ 'mbs-ui-kit:list-editor.add' | i18next: { format: 'capitalize' } }}
      </mbs-button>
    </div>
  </div>
</div>

@if (copyData(); as copyData) {
  <div class="mbs-form-group">
    <div
      class="mbs-form-dropdown_data"
      [class.-filled]="copyData.size > 0">
      @for (item of copyData; track item) {
        <div class="mbs-form-dropdown_data-item">
          <div class="form-row">
            <div class="col overflow-hidden">
              <mbs-text-ellipsis
                [placement]="'auto'"
                [tooltip]="item"
                [tooltipClass]="'tooltip-lg'">
                {{ item }}
              </mbs-text-ellipsis>
            </div>
            <div class="col-auto text-end">
              <mbs-button
                [icon]="'ico ico-Close'"
                [isCtrl]="true"
                [size]="MbsSize.sm"
                [title]="'Delete'"
                [type]="'danger'"
                (click)="handleDelete(item)" />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
